var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0827 21.5417L2.16602 43.8334L24.4577 35.9375M6.33268 4.25002H6.35352M43.8327 14.6667H43.8535M29.2493 2.16669H29.2702M43.8327 39.6667H43.8535M43.8327 2.16669L39.166 3.72919C37.8376 4.17166 36.7042 5.06177 35.9594 6.24736C35.2146 7.43295 34.9047 8.84042 35.0827 10.2292C35.291 12.0209 33.8952 13.625 32.0618 13.625H31.2702C29.4785 13.625 27.9368 14.875 27.6035 16.625L27.166 18.8334M43.8327 25.0834L42.1243 24.3959C40.3327 23.6875 38.3327 24.8125 37.9993 26.7084C37.7702 28.1667 36.4993 29.25 35.0202 29.25H33.416M20.916 2.16669L21.6035 3.87502C22.3118 5.66669 21.1868 7.66669 19.291 8.00002C17.8327 8.20835 16.7493 9.50002 16.7493 10.9792V12.5834",
    stroke: "#044D9F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9161 25.0833C24.9369 29.1042 26.8119 33.7708 25.0828 35.5C23.3536 37.2292 18.6869 35.3542 14.6661 31.3333C10.6453 27.3125 8.77026 22.6458 10.4994 20.9167C12.2286 19.1875 16.8953 21.0625 20.9161 25.0833Z",
    stroke: "#044D9F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFun);
export default __webpack_public_path__ + "static/media/fun.c8e682dba7c8c151fe6110c5f1e17641.svg";
export { ForwardRef as ReactComponent };